// extracted by css-extract-rspack-plugin
export default {"root":"DwETP22zbpkRcFT7","main":"qzZfQFPXE_0sY2Og","logo":"JYGwY5BsROEfKM2N","content":"Ap9BAvwBbG0DHJQ_","actions":"oCYy4EpoOEE2Si5P"};